/* eslint-disable */
	 /* pathと対応するvueファイルを記述する。pathは、html内の「router-link to=」に合わせること。
また、pathはURLにもなり得る部分である。（例：path:’/foo’ なら、http://example.com/foo） */
const path = '../components';
const path_commmon = path + '/common/';

import { createRouter, createWebHistory } from 'vue-router'

import Home from '../components/Home/Home.vue'
import Ichiran from '../components/Home/Ichiran.vue'
import Condition from '../components/Home/Condition.vue'
import Policy from '../components/Home/Policy.vue'
import Taiken from '../components/User/User.vue'
import Shakyo from '../components/Shakyo/Shakyo.vue'
import ShakyoHome from '../components/Shakyo/ShakyoHome.vue'

const routes = [
    { path: '/', name:'home', component: Home },
    { path: '/Ichiran', name:'Ichiran', component: Ichiran },
    { path: '/Policy', name:'Policy', component: Policy },
    { path: '/Condition', name:'Condition', component: Condition },

    { path: '/:shakyo/Taiken', name:'TaikenTop', component: Taiken },
    { path: '/:shakyo/Taiken/:cmd', name:'TaikenIchiran', component: Taiken },
    { path: '/:shakyo/Taiken/:cmd/:id', name:'TaikenShosai', component: Taiken },
    
    { path: '/:shakyo/Kanri', name:'Shakyo', component: Shakyo },
    { path: '/:shakyo/Kanri/Home', name:'ShakyoHome', component: ShakyoHome },
    { path: '/:shakyo/Kanri/CSV', name:'ShakyoCSV', component: () => import("../components/Shakyo/ShakyoInputCSV.vue") },
    { path: '/:shakyo/Kanri/Jizen', name:'ShakyoJizen', component: () => import("../components/Shakyo/Jizen/ShakyoJizen.vue") },
    { path: '/:shakyo/Kanri/Jizen/:cmd', name:'ShakyoJizenList', component: () => import("../components/Shakyo/Jizen/ShakyoJizen.vue" ) },
    { path: '/:shakyo/Kanri/Jizen/:cmd/:id', name:'ShakyoJizenDetail', component: () => import( "../components/Shakyo/Jizen/ShakyoJizen.vue" ) },
    { path: '/:shakyo/Kanri/Taiken/:cmd', name:'ShakyoTaikenList', component: () => import("../components/Shakyo/Taiken/ShakyoTaiken.vue" ) },
    { path: '/:shakyo/Kanri/Taiken/:cmd/:id', name:'ShakyoTaikenDetail', component: () => import( "../components/Shakyo/Taiken/ShakyoTaiken.vue" ) },
    { path: '/:shakyo/Kanri/Jigo', name:'ShakyoJigo', component: () => import("../components/Shakyo/Jigo/ShakyoJigo.vue") },
    { path: '/:shakyo/Kanri/Jigo/:cmd', name:'ShakyoJigoList', component: () => import("../components/Shakyo/Jigo/ShakyoJigo.vue" ) },
    { path: '/:shakyo/Kanri/Jigo/:cmd/:id', name:'ShakyoJigoDetail', component: () => import( "../components/Shakyo/Jigo/ShakyoJigo.vue" ) },
    { path: '/:shakyo/Kanri/User/:cmd/', name:'ShakyoUserList', component: () => import("../components/Shakyo/User/ShakyoUser.vue" ) },
    { path: '/:shakyo/Kanri/User/:cmd/:id/', name:'ShakyoUserDetail', component: () => import( "../components/Shakyo/User/ShakyoUser.vue" ) },
    { path: '/:shakyo/Kanri/User/:cmd/:user_id/:id/', name:'ShakyoUserJyokyo', component: () => import( "../components/Shakyo/User/ShakyoUser.vue" ) },
    { path: '/:shakyo/Kanri/MailLogin', name:'MailLogin', component: () => import('../components/Shakyo/ShakyoMailLogin.vue') },
    { path: '/:shakyo/Kanri/MailLogin/Renewal', name:'MailRenewal', component: () => import('../components/Shakyo/ShakyoRenewal.vue') },
    { path: '/:shakyo/Kanri/Shomei/:cmd', name:'ShakyoShomei', component: ()=> import('../components/Shakyo/Shomei/ShakyoShomei.vue') },
    { path: '/:shakyo/Kanri/Shomei/:cmd/:id', name:'ShakyoShomeiEdit', component: ()=> import('../components/Shakyo/Shomei/ShakyoShomei.vue') },
    { path: '/:shakyo/Kanri/Mail/:cmd', name:'ShakyoMail', component: ()=> import('../components/Shakyo/Mail/ShakyoMail.vue') },
    { path: '/:shakyo/Kanri/Mail/:cmd/:kubun/', name:'ShakyoMailEdit', component: ()=> import('../components/Shakyo/Mail/ShakyoMail.vue') },
    { path: '/:shakyo/Kanri/Form/:cmd', name:'ShakyoForm', component: ()=> import('../components/Shakyo/Form/ShakyoForm.vue') },
    { path: '/:shakyo/Kanri/Form/:cmd/:syurui', name:'ShakyoFormEdit', component: ()=> import('../components/Shakyo/Form/ShakyoForm.vue') },
//    { path: '/:shakyo/Kanri/Form/:cmd/:id', name:'ShakyoFormEdit', component: ()=> import('../components/Shakyo/Form/ShakyoForm.vue') },
    
    { path: '/:shakyo/Taiken/Shomei/:user_id/:id/', name:'ShomeiDownload', component: () => import( "../components/Shomei/ShomeiDownload.vue" ) },
    
    { path: '/:shakyo/Kanri/Shomei/:user_id/:id/', name:'ShakyoShomeiDownload', component: () => import( "../components/Shakyo/Shomei/ShomeiDownload.vue" ) },
    { path: '/:shakyo/Kanri/Shomei/upload_preview', name:'ShakyoShomeiPreview', component: () => import( "../components/Shakyo/Shomei/ShomeiPreview.vue" ) },
    { path: '/:shakyo/Kanri/System', name:'ShakyoSystem', component: () => import( "../components/Shakyo/System/ShakyoSystem.vue" ) },
    

    { path: '/Sanko', name:'Kanri', component: () => import( "../components/Kanri/KanriShakyo.vue" ) },

    { path: '/Sanko/Login', name:'KanriLogin', component: () => import( "../components/Kanri/KanriMailLogin.vue" ) },
    { path: '/Sanko/Renewal', name:'KanriRenewal', component: () => import( "../components/Kanri/KanriRenewal.vue" ) },

    { path: '/Shakyo_toroku', name:'ShakyoAdd', component: () => import( "../components/Shakyo/Add/ShakyoSignin.vue" ) },

    { path: '/:shakyo/Shakyo_toroku', name:'ShakyoKobetsuAdd', component: () => import( "../components/Shakyo/Add/ShakyoSignin.vue" ) },

    /*
    { path: '/login', name:'IppanLogin', component: () => import( "../components/Ippan/certification_old/Login.vue" ) },
    { path: '/:cmd', name:'IppanSearch', component: () => import( "../components/Ippan/Shakyo_old/Shakyo.vue" ) },
    { path: '/:cmd/:id', name:'IppanDetail', component: () => import( "../components/Ippan/Shakyo_old/Shakyo.vue" ) },*/

    { path: '/:shakyo/Volunteer/login', name:'IppanShakyoLogin', component: () => import("../components/Ippan/certification/Login.vue" ) },
    { path: '/:shakyo/Volunteer/:cmd', name:'IppanShakyoSearch', component: () => import("../components/Ippan/Shakyo/Shakyo.vue" ) },
    { path: '/:shakyo/Volunteer/:cmd/:id', name:'IppanShakyoDetail', component: () => import("../components/Ippan/Shakyo/Shakyo.vue" ) },
    
    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;